<template>
    <div >
      <div class="loader-wrapper"  v-show="isLoading">
        <div class="loader">Loading...</div>
      </div>
      <ReferralForm @stop-load="isLoading = false" @startLoad = "isLoading = true"/>
    </div>
  </template>
  <script>
  import ReferralForm from "../components/ReferralForm.vue";
  
  export default {
    name: 'App',
    components: {
      ReferralForm
    },
    data () {
    return {
      isLoading: false,
    }
  }
  }
  </script>
  